import { useNavigate, Link } from "react-router-dom";
import {
  Nav,
  Navbar,
  Container,
  NavDropdown,
  Dropdown,
  Image,
} from "react-bootstrap";
import { signOut } from "firebase/auth";
import { useState } from "react";

import Logo from "../assets/logo2.png";
import { auth } from "../config/firebase";
import { Loading } from "../components";
import { Nome } from "../components/Formatar";

const Header = (props) => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const logoutFirebase = async () => {
    setLoading(true);

    try {
      await signOut(auth);
      navigate("/login");
    } finally {
      setLoading(false);
    }
  };

  const UsuarioDropdown = () => (
    <Dropdown align="end">
      <Dropdown.Toggle
        variant="light"
        className="border-0 bg-white shadow-none d-flex align-items-center"
      >
        <Image
          src={props.foto}
          width={36}
          height={36}
          roundedCircle
          className="me-2"
        />

        <span className="fw-semibold text-capitalize">{Nome(props.nome)}</span>
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item onClick={logoutFirebase}>Sair</Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  );

  return (
    <>
      {loading && <Loading />}

      <Navbar
        bg="white"
        expand="lg"
        className="shadow-sm border-bottom py-2 d-print-none"
      >
        <Container>
          <Navbar.Brand as={Link} to="/home">
            <img src={Logo} height="42" alt="Expresso Embaixador" />
          </Navbar.Brand>

          <Navbar.Toggle aria-controls="navbar" />

          <Navbar.Collapse id="navbar">
            <Nav className="me-auto">
              <Nav.Link as={Link} to="/home">
                Início
              </Nav.Link>

              <NavDropdown title="Financeiro" id="financeiro">
                <NavDropdown.Header>2026</NavDropdown.Header>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=0826">
                  Agosto
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=0926">
                  Setembro
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=1026">
                  Outubro
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=1126">
                  Novembro
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=1226">
                  Dezembro
                </NavDropdown.Item>

                <NavDropdown.Header>2027</NavDropdown.Header>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=0127">
                  Janeiro
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=0227">
                  Fevereiro
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=0327">
                  Março
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=0427">
                  Abril
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=0527">
                  Maio
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=0627">
                  Junho
                </NavDropdown.Item>

                <NavDropdown.Item as={Link} to="/financeiro?competencia=0727">
                  Julho
                </NavDropdown.Item>
              </NavDropdown>

              <Nav.Link as={Link} to="/contrato">
                Contrato
              </Nav.Link>

              <Nav.Link as={Link} to="/contato">
                Fale Conosco
              </Nav.Link>

              {/* Apenas Mobile */}
              <Nav.Link
                className="d-lg-none border-top mt-2 pt-2"
                onClick={logoutFirebase}
              >
                Sair
              </Nav.Link>
            </Nav>

            {/* Apenas Desktop */}
            <div className="d-none d-lg-block">
              {props.nome && props.foto ? (
                <UsuarioDropdown />
              ) : (
                <Nav>
                  <Nav.Link onClick={logoutFirebase}>Sair</Nav.Link>
                </Nav>
              )}
            </div>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </>
  );
};

export default Header;
